module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_3009.de9e86d1.png";